import { ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { LoggerService } from 'projects/common/src/app/services/logger.service';
import { IRequestError } from 'projects/common/src/app/interfaces/communication/request';

export class ErrorHandlerService extends ErrorHandler {

  constructor() {
    super();
  }

  /**
   * Manejador de errores
   * @model Communication model
   * @param error error
   */
  public handleError(error: HttpErrorResponse | IRequestError): void {
    if (error instanceof HttpErrorResponse) {
      // Backend returns unsuccessful response codes such as 404, 500 etc.
      LoggerService.error('Backend returned status code: ', error.status);
      LoggerService.error('Response body:', error.message);
    } else {
      // A client-side or network error occurred.
      // LoggerService.error('Error message:', error.message, error.extra);
      LoggerService.error('Error message:', error.stack, error.extra);
      // super.handleError(error);
    }
  }
}
